module.exports = __webpack_public_path__ + "static/media/Gobierno.abcd4cbf.svg";